import { removeTrapFocus, trapFocus } from "./global"; // eslint-disable-line

class DetailsModal extends HTMLElement {
	constructor() {
		super();
		this.detailsContainer = this.querySelector("details");
		this.summaryToggle = this.querySelector("summary");
		this.detailsContainer.addEventListener(
			"keyup",
			(event) => event.code.toUpperCase() === "ESCAPE" && this.close(),
		);
		this.summaryToggle.addEventListener(
			"click",
			this.onSummaryClick.bind(this),
		);
		this.querySelector('button[type="button"]').addEventListener(
			"click",
			this.close.bind(this),
		);
		this.summaryToggle.setAttribute("role", "button");
		this.summaryToggle.setAttribute("aria-expanded", "false");
	}

	isOpen() {
		return this.detailsContainer.hasAttribute("open");
	}

	onSummaryClick(event) {
		const details = event.target.closest("details");

		event.preventDefault();
		if (event.target.classList.contains("header__icon--search")) return;
		if (details.hasAttribute("open")) {
			this.close();
		} else {
			this.open(event);
		}
	}

	onBodyClick(event) {
		if (!this.contains(event.target)) this.close(false);
	}

	open(event) {
		this.onBodyClickEvent =
			this.onBodyClickEvent || this.onBodyClick.bind(this);
		event.target.closest("details").setAttribute("open", true);
		document.body.addEventListener("click", this.onBodyClickEvent);

		trapFocus(
			this.detailsContainer.querySelector('[tabindex="-1"]'),
			this.detailsContainer.querySelector('input:not([type="hidden"])'),
		);
	}

	close(focusToggle = true) {
		removeTrapFocus(focusToggle ? this.summaryToggle : null);
		this.detailsContainer.removeAttribute("open");
		document.body.removeEventListener("click", this.onBodyClickEvent);
	}
}

customElements.get("details-modal") ||
	customElements.define("details-modal", DetailsModal); // eslint-disable-line

export default DetailsModal;
